import { render } from "./CustomizationGroup.vue?vue&type=template&id=3a1b9891&scoped=true"
import script from "./CustomizationGroup.vue?vue&type=script&lang=js"
export * from "./CustomizationGroup.vue?vue&type=script&lang=js"

import "./CustomizationGroup.vue?vue&type=style&index=0&id=3a1b9891&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1b9891"]])

export default __exports__